module.exports = __webpack_public_path__ + "media/images/farey/social/Twitter2-28098ea8da5ae9c0f760907b0389d41d.png";